export function getUrlWithAtlOrigin(href, originId) {
  if (!href || !originId) {
    return href;
  }
  var url;
  try {
    // URL throws a TypeError if href is not valid
    url = new URL(href);
  } catch (_unused) {
    return href;
  }
  if (url.searchParams.has('atlOrigin')) {
    return href;
  }
  url.searchParams.set('atlOrigin', originId);
  return url.toString();
}